import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import IconButton from 'components/common/IconButton';
import IconNote from 'components/icons/IconNote';
import NarrativeCreateEditDialog from 'components/workflow/NarrativeCreateEditDialog';

const styles = theme => ({
  button: {
    width: 36,
    height: 36,
    marginTop: 6,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  buttonSelected: {
    color: theme.palette.primary[500],
  },
  iconNote: {
    width: 23,
    height: 23,
  },
});

class ProductClaimNarrativeField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
  }

  onButtonClick() {
    this.setState({ dialogOpen: true });
  }

  onDialogClose() {
    this.setState({ dialogOpen: false });
  }

  render() {
    const { input, disabled, classes } = this.props;
    const { dialogOpen } = this.state;

    return (
      <Fragment>
        <IconButton
          className={classNames(classes.button, {
            [classes.buttonSelected]: input.value,
          })}
          variant="raised"
          onClick={this.onButtonClick}
          tooltipContent={input.value ? `Narrative: ${input.value}` : 'Narrative'}
          disabled={disabled}
        >
          <IconNote className={classes.iconNote} />
        </IconButton>
        <NarrativeCreateEditDialog
          open={dialogOpen}
          onClose={this.onDialogClose}
          form={`${input.name}-narrativeCreateEdit`}
          initialValues={{
            Narrative: input.value,
          }}
          onSubmitSuccess={(values) => {
            input.onChange(values.Narrative);
          }}
          onClear={() => {
            input.onChange(null);
          }}
        />
      </Fragment>
    );
  }
}

ProductClaimNarrativeField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    buttonSelected: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconNote: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimNarrativeField.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(ProductClaimNarrativeField);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimNarrativeField.js